import { memo } from 'react';
import { Ancillarie } from '../../Summary.model';
import { AncillarieItem } from '../SummaryAncillarie';
import { ErrorBoundaryProvider } from '../../../../../providers/ErrorBoundaryProvider';

interface SummaryAncillariesProps {
	ancillaries?: Ancillarie[];
}
export const SummaryAncillaries = memo(
	function SummaryAncillaries({ ancillaries }: SummaryAncillariesProps) {
		return (
			<ErrorBoundaryProvider>
				{ancillaries?.map((ancillarie) => {
					return <AncillarieItem key={ancillarie.code} ancillarie={ancillarie}></AncillarieItem>;
				})}
			</ErrorBoundaryProvider>
		);
	},
	(prev, next) => JSON.stringify(prev) === JSON.stringify(next)
);
SummaryAncillaries.displayName = 'SummaryAncillaries';
